// import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { State, Dispatch } from '../store'
import { REGEX_FIRST_PATH } from '../constants'
import { useLocation } from 'react-router-dom'

const PANEL_WIDTH_DEFAULTS: Record<string, { default: number; primary?: number; secondary?: number }> = {
  devices: { default: 400 },
  networks: { default: 450 },
  connections: { default: 450 },
  files: { default: 450 },
  file: { default: 450 },
  settings: { default: 350 },
  account: { default: 300 },
  organization: { default: 350 },
  products: { default: 450, primary: 330, secondary: 400 },
  scripts: { default: 550 },
  script: { default: 450, primary: 330, secondary: 400 },
  runs: { default: 330 },
}

export function getPanelWidthDefault(
  routeKey: string,
  suffix?: 'primary' | 'secondary',
  fallback: number = 9999,
): number {
  return suffix
    ? PANEL_WIDTH_DEFAULTS[routeKey]?.[suffix] || PANEL_WIDTH_DEFAULTS[routeKey]?.default || fallback
    : PANEL_WIDTH_DEFAULTS[routeKey]?.default || fallback
}

export function usePanelWidth(suffix?: string): [number, (value: number) => void] {
  const { ui } = useDispatch<Dispatch>()
  const location = useLocation()

  const match = location.pathname.match(REGEX_FIRST_PATH)
  const routeKey = match ? match[0].substring(1) : ''
  const key = suffix ? `${routeKey}-${suffix}` : routeKey
  const panelWidth = useSelector((state: State) => state.ui.panelWidth)
  const defaultWidth = getPanelWidthDefault(routeKey, suffix as 'primary' | 'secondary' | undefined)

  const setPanelWidth = (value: number) => {
    console.log('setPanelWidth', key, value)
    ui.setPersistent({ panelWidth: { ...panelWidth, [key]: value } })
  }

  return [panelWidth[key] || defaultWidth, setPanelWidth]
}
